import React from "react";
import StackedBar from "./StackedBar";

interface ProgressBarProps {
    className?: string;
    color?: string;
    background?: string;
    progress?: number;
    height?: string;
    bottom?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = (
        {
            className,
            color = '#00ff66',
            background = '#292929',
            progress = 10,
            height = '4px',
            bottom = true,
        }) => {

    const style: { [key: string]: string | number | boolean } = {};

    if (bottom) {
        style['position'] = 'absolute';
        style['bottom'] = 0;
    }

    return (
            <StackedBar
                    style={style}
                    sx={{
                        width: "100%",
                        opacity: 0,
                        overflow: "hidden",
                        height: 0,
                        transition: "height 1s ease-in-out, opacity 1s ease-in-out",
                        ...progress !== 1 && {
                            opacity: 1,
                        }
                    }}
                    height={(progress === 1 || progress === 0) ? "0" : height}
                    stacks={[
                        {
                            background: color,
                            start: 0,
                            end: progress
                        },
                        {
                            // background: background,
                            start: progress,
                            end: 1
                        },
                    ]}
            />
    );
};


export default ProgressBar;
